<template>
    <ul class="segmentedControl" v-bind:style="customStyles">
        <li
            v-for="item in items"
            v-bind:key="String(item.value)"
            v-gtm:page="props.gtmPage"
            v-gtm:type="props.gtmType"
            v-gtm:label="item.gtmLabel ?? props.gtmLabel"
            v-gtm:feature="props.gtmPage ? getGtmFeature(item.value) : undefined"
            v-gtm:@click
            v-bind:class="{ _active: modelValue === item.value }"
            class="segmentedControl-item"
            v-on:click="modelValue = item.value"
        >
            <span class="segmentedControl-link">
                {{ item.title }}
            </span>
        </li>
    </ul>
</template>

<script lang="ts" setup generic="T">
    import { computed } from 'vue';

    interface ControlItem<T = unknown> {
        value: T;
        title: string;
        gtmLabel?: string;
    }

    interface Props<T = unknown> {
        items: ControlItem<T>[];
        gtmPage?: string;
        gtmType?: string;
        gtmLabel?: string;
        backgroundColor?: string;
        color?: string;
        activeBackgroundColor?: string;
        activeColor?: string;
    }

    const props = defineProps<Props<T>>();

    const modelValue = defineModel<T>();

    function getGtmFeature(value: T): string {
        const featureMap: Record<string, string> = {
            'unlimited': 'Unlimited',
            'h2h': 'H2h',
            '3players': '3players',
            '6players': '6players',
        };

        return featureMap[String(value)] || String(value);
    }

    const customStyles = computed(() => {
        const styles: Record<string, string> = {};

        if (props.backgroundColor) {
            styles['--segmentedControl-bgColor'] = props.backgroundColor;
        }
        if (props.color) {
            styles['--segmentedControl-color'] = props.color;
        }
        if (props.activeBackgroundColor) {
            styles['--segmentedControl-activeBgColor'] = props.activeBackgroundColor;
        }
        if (props.activeColor) {
            styles['--segmentedControl-activeColor'] = props.activeColor;
        }

        return styles;
    });
</script>

<style lang="scss" scoped>
    @import "@/components/common/segmentedControl/SegmentedControl";
</style>
